import { Component, ViewEncapsulation, SecurityContext } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { environment } from 'environments/environment'

import { Observable } from 'rxjs/Observable'
import { ActivatedRoute, Router } from '@angular/router'
import { AuthService } from '../../../../_services'

import { Broadcaster } from 'environments/broadcaster'

import { PagerService } from '../../../../_services/pager.service'
import { LoaderService } from '../../../../_services/loader.service'
import { process, State } from '@progress/kendo-data-query'
import { ExcelExportData } from '@progress/kendo-angular-excel-export'
import { GroupDescriptor } from '@progress/kendo-data-query'
import { SelectableSettings } from '@progress/kendo-angular-grid'
import {
  GridDataResult,
  DataStateChangeEvent,
} from '@progress/kendo-angular-grid'
import { RowClassArgs } from '@progress/kendo-angular-grid'
import Swal from 'sweetalert2'

import { DomSanitizer } from '@angular/platform-browser'

declare var $: any

const distinctZone = (data) =>
  data.filter(
    (x, idx, xs) => xs.findIndex((y) => y.zoneName === x.zoneName) === idx,
  )
const distinctWard = (data) =>
  data.filter(
    (x, idx, xs) => xs.findIndex((y) => y.wardName === x.wardName) === idx,
  )
const distinctStatus = (data) =>
  data.filter(
    (x, idx, xs) =>
      xs.findIndex((y) => y.verifyStatus === x.verifyStatus) === idx,
  )
const distinctDoc = (data) =>
  data.filter(
    (x, idx, xs) => xs.findIndex((y) => y.filePath === x.filePath) === idx,
  )
const distinctClient = (data) =>
  data.filter(
    (x, idx, xs) =>
      xs.findIndex((y) => y.CLIENTMGRNAME === x.CLIENTMGRNAME) === idx,
  )

@Component({
  selector: 'consumerList-cmp',
  templateUrl: './consumerList.component.html',
  encapsulation: ViewEncapsulation.None,
  styles: [
    '.green .codeColumn { color: green; font-weight: bold; background-color: #00800038; } .red .codeColumn { color: red; font-weight: bold; background-color: #ff00003b; }',
  ],
})
export class ConsumerListComponent {
  prjID: any
  public consumers: any[]
  refID: any
  consumerName: any
  consumerCD: any
  buildingID: any
  buildingName: any
  ownerName: any
  houseNo: any
  street: any
  landmark: any
  address: any
  pin: any
  mobileNo: any
  email: any
  bldTypeID: any
  BldTypName: any
  buildingCategoryId: any
  buildingCategoryName: any
  UccCategoryID: any
  catCD: any
  UCCCategory: any
  area: any
  UOM: any
  stdRate: any
  agreedRate: any
  billType: any
  verifyStatus: any
  billStartDt: any
  item: any
  pager: any = {}
  pagedItems: any
  showLoader: boolean
  defaultStartDate: any
  defaultEndDate: any
  dataRangeModal: any
  startDate: any
  endDate: any
  downloadPath: any

  public percentMtr = false
  percentage = 0
  public onUploadComplete = false
  downloadURL
  backgroundImage

  public state: State = {
    skip: 0,
    take: 100,
    // Initial filter descriptor
    filter: {
      logic: 'and',
      filters: [],
    },
  }
  public pageSize: any
  public checkboxOnly = false
  public mode = 'multiple'
  public selectableSettings: SelectableSettings
  public distinctZone: any[]
  public distinctWard: any[]
  public distinctStatus: any[]
  public distinctDoc: any[]
  public distinctClient: any[]
  public groups: GroupDescriptor[] = []
  public view: Observable<GridDataResult>
  public gridDataConsumerList: any
  public hiddenColumns: string[] = []
  titleData: string
  successMsg: boolean = false
  syncing: boolean
  loaderClass: string
  consumerCode: any
  empUploadImgModel: any
  consumerID: any
  public isHidden(columnName: string): boolean {
    return this.hiddenColumns.indexOf(columnName) > -1
  }

  public groupChange(groups: GroupDescriptor[]): void {
    this.groups = groups
    this.loadProducts()
  }

  private loadProducts(): void {
    this.gridDataConsumerList = process(this.consumers, { group: this.groups })
  }

  public allData(): ExcelExportData {
    const result: ExcelExportData = {
      data: this.consumers,
    }
    return result
  }

  constructor(
    private broadcaster: Broadcaster,
    private auth: AuthService,
    private http: HttpClient,
    private routes: ActivatedRoute,
    private router: Router,
    private pagerService: PagerService,
    private loaderService: LoaderService,
    private domSanitizer: DomSanitizer,
  ) {
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val
    })
    this.allData = this.allData.bind(this)
    var date = new Date()
    var firstDay = new Date(date.getFullYear() - 3, date.getMonth() - 8, 1)
    this.defaultStartDate =
      firstDay.getFullYear() +
      '-' +
      (firstDay.getMonth() + 1) +
      '-' +
      firstDay.getDate()
    this.defaultEndDate =
      date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
    this.dataRangeModal = {
      beginDate: {
        year: firstDay.getFullYear(),
        month: firstDay.getMonth() + 1,
        day: firstDay.getDate(),
      },
      endDate: {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate(),
      },
    }
  }

  syncData() {
    this.syncing = true
    this.loaderClass = 'fas fa-sync fa-spin'
    this.getConsumers(this.prjID, 1, 10000)
    this.syncing = false
    this.loaderClass = 'fas fa-sync'
  }

  filterModal() {
    $('#FilterModal').modal('show')
  }

  uploadMOU(data) {
    console.log('173', data)

    $('#doc').css('border', 'none')
    this.successMsg = false
    this.percentMtr = false
    this.onUploadComplete = false
    this.empUploadImgModel = null
    this.consumerID = data.ID
    this.consumerCode = data.consumerCD
    console.log('Upload btn', this.consumerCode)
    $('#mouModel').modal('show')
  }

  // image upload
  detectFiles($event) {
    $('#doc').css('border', 'none')
    this.percentMtr = true
    this.percentage = 0

    // get file
    const file1 = $event.target.files[0]

    // create storage ref
    const storageRef = firebase.storage().ref('/MOU/' + this.consumerCode)
    // console.log("FILENAME", file1.name);
    // Upload file
    const task = storageRef.put(file1)

    // Upload progress bar
    task.on(
      'state_changed',
      (snapshot: any) => {
        this.percentage =
          (task.snapshot.bytesTransferred / task.snapshot.totalBytes) * 100
        // console.log(this.percentage);
        this.percentMtr = true

        if (this.percentage == 100) {
          this.onUploadComplete = true
        }
      },
      (error) => {
        console.error(error)
        this.percentMtr = false
      },
      () => {
        storageRef.getDownloadURL().then(
          (downloadURL) => {
            this.downloadURL = downloadURL
            console.log('This is download URL', downloadURL)
            this.backgroundImage =
              this.downloadURL &&
              this.downloadURL != null &&
              this.downloadURL !== ''
                ? this.domSanitizer.sanitize(
                    SecurityContext.STYLE,
                    'url(' + this.downloadURL + ')',
                  )
                : this.domSanitizer.sanitize(SecurityContext.STYLE, 'none')
            // this.onChange(downloadURL);
          },
          (error) => {
            console.error('upload rejected', error)
            this.percentMtr = false
          },
        )
      },
    )
  }

  uploadMOUDoc() {
    if (this.empUploadImgModel == null) {
      alert('Please add a document first!')
      $('#doc').css('border', '1px solid red')
      return
    }
    var obj = {
      id: this.consumerID,
      filePath: this.downloadURL,
    }
    console.log('upload data', obj)
    this.http.post(environment.apiUrl + 'updateMOU', obj).subscribe((data) => {
      console.log(data)
      this.successMsg = true
      this.syncData()
      $('#mouModel').modal('hide')
      this.titleData = 'Document uploaded successfully.'
      Swal({
        title: this.titleData,
        showCancelButton: false,
        type: 'success',
        imageUrl: '../../../../../assets/img/success.png',
      })
      // setTimeout(function () {
      // 	$('#mouModel').modal('hide');
      // }, 1500);
    })
  }

  AddConsumerModal() {
    this.broadcaster.broadcast('addnewConsumer', null)
  }

  editConsumer(consumer) {
    this.broadcaster.broadcast('addnewConsumer', consumer)
  }

  downloadDocument(documentLink) {
    if (documentLink && documentLink != 'undefined') {
      window.open(documentLink, '_blank')
    } else if (documentLink == 'undefined') {
      this.titleData =
        'An error occured while uploading the document. Please upload again.'
      Swal({
        title: this.titleData,
        showCancelButton: false,
        type: 'error',
        imageUrl: '../../../../../assets/img/sorry.png',
      })
    } else {
      this.titleData = 'No MOU Document found. Please EDIT and upload MOU.'
      Swal({
        title: this.titleData,
        showCancelButton: false,
        type: 'error',
        imageUrl: '../../../../../assets/img/nodoc.gif',
      })
    }
  }
  createInvoice(invoice) {
    this.router.navigate([
      '/home/crm/kcc/createInvoice',
      invoice.consumerCD,
      'New',
    ])
  }
  download_file() {
    let fileToDownload =
      'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/527c7dd3-1796-4c6a-9f00-3a9001a97b87/dch6sdb-43fce67a-7ca2-4f93-8172-765e821b526b.jpg/v1/fill/w_1024,h_1204,q_75,strp/shaktimaan_popheadshot_by_truezacks_dch6sdb-fullview.jpg?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzUyN2M3ZGQzLTE3OTYtNGM2YS05ZjAwLTNhOTAwMWE5N2I4N1wvZGNoNnNkYi00M2ZjZTY3YS03Y2EyLTRmOTMtODE3Mi03NjVlODIxYjUyNmIuanBnIiwiaGVpZ2h0IjoiPD0xMjA0Iiwid2lkdGgiOiI8PTEwMjQifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uud2F0ZXJtYXJrIl0sIndtayI6eyJwYXRoIjoiXC93bVwvNTI3YzdkZDMtMTc5Ni00YzZhLTlmMDAtM2E5MDAxYTk3Yjg3XC90cnVlemFja3MtNC5wbmciLCJvcGFjaXR5Ijo5NSwicHJvcG9ydGlvbnMiOjAuNDUsImdyYXZpdHkiOiJjZW50ZXIifX0.1OBiltxKn-XUaz9MzD0rNZFVXxBJXIcNDqYEs2Vp_So'
    return fileToDownload
  }

  //async setPage(page: number)
  // {
  //   this.loaderService.display(true);
  //   this.pager = this.pagerService.getPager(10000, page);
  //   let response = await fetch(environment.apiUrl + 'consumer' + '?prjId=' + this.prjID+'&pageOffset=' + page + "&pageLimit="  + 10000)
  //   this.consumers = await response.json()
  // }
  /*
   *get Consumer List on page load
   */
  getConsumers(prjID, pageOffset, pageLimit) {
    this.loaderService.display(true)
    if (this.startDate == null || this.endDate == null) {
      this.startDate = this.defaultStartDate
      this.endDate = this.defaultEndDate
    }
    this.http
      .get(
        environment.apiUrl +
          'consumer' +
          '?prjId=' +
          prjID +
          '&pageOffset=' +
          pageOffset +
          '&pageLimit=' +
          pageLimit +
          '&startDate=' +
          this.startDate +
          '&endDate=' +
          this.endDate,
      )
      .subscribe((data) => {
        var result: any
        result = data
        this.consumers = result
        console.log('Consumers', this.consumers)
        this.distinctZone = distinctZone(this.consumers)
        this.distinctWard = distinctWard(this.consumers)
        this.distinctStatus = distinctStatus(this.consumers)
        this.distinctDoc = distinctDoc(this.consumers)
        this.distinctClient = distinctClient(this.consumers)
        this.gridDataConsumerList = process(this.consumers, this.state)
        if (this.consumers.length > 0) {
          this.loaderService.display(false)
        } else {
          this.loaderService.display(false)
        }
        //this.setPage(1);
        this.loaderService.display(false)
      })
  }

  /*
   * filter The Grid Date
   */
  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state
    this.gridDataConsumerList = process(this.consumers, this.state)
    //this.selectedInvoiceCount = this.gridData.data.length
    if (state && state.group) {
      this.gridDataConsumerList = process(this.consumers, this.state)
    }
  }
  /**
     * Column BG color Change
  //   */
  public rowCallback = (context: RowClassArgs) => {
    console.log('data', context.dataItem.filePath)
    switch (context.dataItem.filePath) {
      case 'null':
        return { red: true }
      default:
        return { green: true }
    }
  }

  /*
   * Select Date range
   */

  onDateRangeChanged(dataRange) {
    if (dataRange.beginDate.day > 0) {
      this.startDate =
        dataRange.beginDate.year +
        '-' +
        dataRange.beginDate.month +
        '-' +
        dataRange.beginDate.day
      this.endDate =
        dataRange.endDate.year +
        '-' +
        dataRange.endDate.month +
        '-' +
        dataRange.endDate.day
      this.getConsumers(this.prjID, 1, 10000)
    } else if (dataRange.beginDate.day == 0) {
      this.startDate = this.defaultStartDate
      this.endDate = this.defaultEndDate
      this.getConsumers(this.prjID, 1, 10000)
    }
  }

  ngOnInit() {
    this.prjID = this.auth.getAuthentication().projectId
    this.getConsumers(this.prjID, 1, 10000)
    this.broadcaster.on('consumerSaved').subscribe((message) => {
      this.getConsumers(this.prjID, 1, 10000)
    })
    this.syncing = false
    this.loaderClass = 'fas fa-sync'

    // firebase connectivity for image upload
    var config = {
      authDomain: 'ecogreen-citizen-app.firebaseapp.com',
      apiKey: 'AIzaSyAHMkYkbjRTa9RazdKPJjtOJrdHCZVxxYg',
      databaseURL: 'HttpClient s://ecogreen-citizen-app-2ad05.firebaseio.com/',
      storageBucket: 'ecogreen-citizen-app.appspot.com',
      projectId: 'ecogreen-citizen-app',
    }
    firebase.initializeApp(config)
  }
}



// WEBPACK FOOTER //
// ./src/app/crm/kcc/consumer/consumerList/consumerList.component.ts